import { useLingui } from "@lingui/react";
import { useTheme } from "@stylingcv/hooks";
import { cn } from "@stylingcv/utils";

type Props = {
  size?: number;
  className?: string;
};

export const Logo = ({ size = 160, className }: Props) => {
  const { isDarkMode } = useTheme();
  const { i18n } = useLingui();

  const getLogoSrc = () => {
    const isArabic = i18n.locale.startsWith("ar");

    if (isArabic) {
      return isDarkMode ? "/brand-logos/arabic-logo-white.svg" : "/brand-logos/arabic-logo.svg";
    }

    return isDarkMode ? "/brand-logos/english-logo-white.svg" : "/brand-logos/english-logo.svg";
  };

  return (
    <img
      src={getLogoSrc()}
      width={size}
      height="auto"
      alt="Stylion"
      className={cn("h-auto object-contain", className)}
    />
  );
};
